var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('div',{staticClass:"animated fadeIn"},[_c('basic-heading',{attrs:{"title":"Receive Samples"},scopedSlots:_vm._u([{key:"right-content",fn:function(){return [_c('header-button-group',{attrs:{"button_config":_vm.button_config}})]},proxy:true}],null,false,2247497686)})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }